export default "__VITE_ASSET__f75d8e27__"